<template>
  <div>
    <ol>
      <li v-for="(option, index) in getAllOptions" :key="index">
        <button
            class="option-normal"
            @click="optionChanged(option.option)"
            :class="[option.option === getSelected ? 'option-selected' : '']"
        >
          <span class="image"><img :src=" require(`../assets/icons/${option.src}`) " /></span>
          <span class="option">{{ option.option }}</span>
        </button>
      </li>
    </ol>
  </div>
</template>

<script>

export default {
  name: 'QuizAgeSelect',

  props: {
    options: {
      required: true,
    },
  },

  data() {
    return {
      selected: - 1,
    }
  },

  computed: {
    getAllOptions() {
      return this.options;
    },
    getSelected() {
      return this.selected;
    }
  },

  methods: {
    optionChanged( option ) {
      this.selected = option;
      this.$emit( 'optChanged', this.selected );
    }
  }
}
</script>

<style scoped>

h1 {
  text-align: left;
  margin-bottom: 20px;
}

ol,
li {
  list-style: none;
  padding: 0;
  margin: 0;
}

ol {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  box-shadow: 2px 2px 4px rgba(170, 170, 170, .5);

}

ol li {
  position: relative;
  padding: 0;
  width: 100%;
  background-color: #fff;
  cursor: pointer;
  transition: all .15s ease-in-out;
  font-size: 18px;
  text-align: left;
}

ol li:hover {
  border-color: var(--imc-primary-color);
}
</style>